import { api } from 'api';

const URL = '/reservations/quotes';
const createQuote = async ({ params }) => {
  const { data } = await api.post(URL, params);
  return data;
};

export default createQuote;
